import React, { useCallback, useMemo } from "react";
import { ExpandedConfigurationSection, InputsActions } from "components/inputs/InputsOveriew";
const useTableElements = ({
  inputTypeDescriptions,
  inputTypes
}) => {
  const entityActions = useCallback(
    (listItem) => /* @__PURE__ */ React.createElement(
      InputsActions,
      {
        input: listItem,
        inputTypes,
        inputTypeDescriptions,
        currentNode: null
      }
    ),
    [inputTypes, inputTypeDescriptions]
  );
  const renderExpandedConfigurationDetails = useCallback(
    (input) => /* @__PURE__ */ React.createElement(ExpandedConfigurationSection, { input, inputTypeDescriptions }),
    [inputTypeDescriptions]
  );
  const expandedSections = useMemo(
    () => ({
      configuration: {
        title: "Configuration",
        content: renderExpandedConfigurationDetails
      }
    }),
    [renderExpandedConfigurationDetails]
  );
  return {
    entityActions,
    bulkActions: /* @__PURE__ */ React.createElement(React.Fragment, null, "bulk"),
    expandedSections
  };
};
export default useTableElements;
